export default __webpack_public_path__ + "static/foodtrack-presentation-c58106442b66d48f89998b51d31ff518.png";